import {useCurrentUser} from '../store/currentUser';
/**
 * Get the current user's ID.
 * @returns User ID
 */
export const getUserId = () => useCurrentUser.getState().user.userId;
